import axios from "axios";

// send the form data entered by the user
export const giveawayData = async (
  firstname,
  lastname,
  email,
  day,
  answer,
  correct,
  newsletter
) => {
  const url = "/adventskalender/api";
  const headers = {
    "content-type": "application/json",
  };

  return axios
    .post(
      url,
      { firstname, lastname, email, day, answer, correct, newsletter },
      { headers: headers }
    )
    .then(function (response) {
      //console.log(response.data);
      //console.log(response.status);
      return response.status;
      // return response.data;
    })
    .catch(function (error) {
      //console.log(error);
      if (error.response) {
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        return error.response.status;
      }
    });
};
